let data = [
  {
    name: "Trang chủ",
    icon: "trangchu.svg",
    path: "/home",
    id: 48,
    childrens: [],
  },
  {
    path: "",
    id: 1,
    name: "Quản lý thu BCDT",
    icon: "qlbcdt.svg",
    childrens: [
      {
        path: "",
        name: "Quản lý thu BCDT",
        icon: "",
      },
      {
        path: "/flow-bcdt",
        id: 2,
        name: "Theo dõi nộp BCDT",
        icon: "",
      },
      {
        path: "/data-bcdt",
        name: "Quản lý dữ liệu BCDT",
        id: 3,
        icon: "",
      },
    ],
  },

  {
    name: "Xuất công văn",
    icon: "xuatcv.svg",
    id: 4,
    path: "",
    childrens: [
      {
        path: "",
        name: "Xuất công văn",
        icon: "",
      },
      {
        name: "Phí quyền hoạt động viễn thông",
        icon: "",
        id: 5,
        path: "/telecom-ficense-fee",
      },
      {
        name: "Phí sử dụng mã, số viễn thông",
        icon: "",
        id: 6,
        path: "/ware-dispatch",
      },
      {
        name: "Lệ phí phân bổ mã, số viễn thông",
        icon: "",
        id: 60,
        path: "dulieuvienthong-60",
      },
      {
        name: "Phí năm đầu phí quyền hoạt động viễn thông",
        icon: "",
        id: 61,
        path: "/dulieuvienthong-61",
      },
      {
        name: "Lệ phí cấp phép phí quyền hoạt động viễn thông",
        icon: "",
        id: 62,
        path: "/dulieuvienthong-62",
      },
      {
        name: "Phí TLM viễn thông dùng riêng, phí thử nghiệm mạng và dịch vụ viễn thông",
        icon: "",
        id: 63,
        path: "/dulieuvienthong-63",
      },
      {
        name: "Phí sửa chữa, bảo dưỡng cáp viễn thông trên biển",
        icon: "",
        id: 64,
        path: "/dulieuvienthong-64",
      },
    ],
  },
  {
    name: "Quản lý thu phí CCDV",
    icon: "qltpccdv.svg",
    id: 7,
    path: "",
    childrens: [
      {
        path: "",
        name: "Quản lý thu phí CCDV",
        icon: "",
      },
      {
        name: "Theo dõi thu phí",
        icon: "",
        id: 8,
        path: "/fee-tracking-CCDV",
      },
      {
        name: "Theo dõi công nợ - Kỳ VT",
        icon: "",
        id: 9,
        path: "/telecom-debt",
      },
      {
        name: "Theo dõi công nợ - Kỳ kế toán",
        icon: "",
        id: 10,
        path: "/accounting-liabilities",
      },
      {
        name: "Theo dõi công nợ lũy kế",
        icon: "",
        id: 11,
        path: "/accumulated-debt",
      },
    ],
  },

  {
    name: "Quản lý thu phí TLM viễn thông công cộng",
    icon: "qltptlm.svg",
    path: "",
    id: 12,
    childrens: [
      {
        path: "",
        name: "Quản lý thu phí TLM viễn thông công cộng",
        icon: "",
      },
      {
        name: "Theo dõi thu phí",
        icon: "",
        path: "/fee-tracking-tlm",
        id: 13,
      },
      {
        name: "Theo dõi công nợ - Kỳ kế toán",
        icon: "",
        path: "/accounting-liabilities-tlm",
        id: 15,
      },
      {
        name: "Theo dõi công nợ lũy kế",
        icon: "",
        path: "/accumulated-debt-tlm",
        id: 16,
      },
    ],
  },
  {
    name: "Quản lý thu phí sử dụng mã,số viễn thông",
    icon: "masovt.svg",
    id: 17,
    path: "",
    childrens: [
      {
        name: "Theo dõi biến động phí",
        icon: "",
        id: 18,
        path: "/fee-list",
      },
      {
        name: "Theo dõi thu phí",
        icon: "",
        id: 19,
        path: "/fee-tracking-ks",
      },
      {
        path: "",
        name: "Quản lý thu phí sử dụng mã, số viễn thông",
        icon: "",
      },
      {
        name: "Theo dõi công nợ - Kỳ VT",
        icon: "",
        id: 20,
        path: "/teleco-ks",
      },
      {
        name: "Theo dõi công nợ - Kỳ kế toán",
        icon: "",
        id: 21,
        path: "/account-ks",
      },
      {
        name: "Theo dõi công nợ lũy kế",
        icon: "",
        id: 22,
        path: "/aclated-ks",
      },
    ],
  },

  // Cáp biển
  {
    name: "Quản lý thu phí một lần",
    icon: "tp1lan.svg",
    id: 23,
    path: "",
    childrens: [
      {
        name: "Quản lý thu phí một lần",
        icon: "",
        path: "",
      },
      {
        name: "Phí TLM viễn thông dùng riêng, Phí thử nghiệm mạng và dịch vụ viễn thông",
        icon: "",
        id: 24,
        path: "/one-time-fee",
      },
      {
        name: "Phí sửa chữa, bảo dưỡng cáp viễn thông trên biển",
        icon: "",
        id: 25,
        path: "/sea-cable",
      },
    ],
  },

  {
    name: "Quản lý thu lệ phí",
    icon: "qlthulephi.svg",
    id: 26,
    path: "",
    childrens: [
      {
        name: "Quản lý thu lệ phí",
        icon: "",
        path: "",
      },
      {
        name: "Lệ phí cấp phép",
        icon: "",
        id: 58,
        path: "/income-fee",
      },

      {
        name: "Lệ phí phân bổ mã, số viễn thông",
        icon: "",
        id: 59,
        path: "/fee-number",
      },
    ],
  },

  {
    name: "Quản lý biên lai",
    icon: "qlbienlai.svg",
    id: 27,
    path: "",
    childrens: [
      {
        path: "",
        name: "Quản lý biên lai",
        icon: "",
      },
      {
        name: "Danh sách biên lai",
        icon: "",
        id: 28,
        path: "/receipt-bcdt",
      },
      {
        name: "Tờ khai thu nộp phí, lệ phí",
        icon: "",
        id: 29,
        path: "/receipt-declarations",
      },
      {
        name: "Tờ khai quyết toán phí, lệ phí",
        icon: "",
        id: 30,
        path: "/receipt-settlement",
      },
    ],
  },
  {
    name: "Quản lý công văn",
    icon: "dispart.svg",
    id: 31,
    path: "/dis-manage",
    childrens: [],
  },
  {
    name: "Quản lý thông tin doanh nghiệp",
    icon: "qldoanhnghiep.svg",
    id: 32,
    path: "/company-list",
    childrens: [],
  },
  {
    name: "Quản lý thu phí nộp chậm các loại phí",
    icon: "chamnop.svg",
    id: 55,
    path: "/sent-slow",
    childrens: [],
  },
  // Xử phạt hành chính
  {
    name: "Xử phạt hành chính",
    icon: "Penalize.svg",
    id: 33,
    path: "/administrative-sanctions",
    childrens: [],
  },
  // Báo cáo thống kê
  {
    name: "Báo cáo thống kê",
    icon: "Statistical.svg",
    path: "",
    id: 34,
    childrens: [
      {
        path: "",
        name: "Báo cáo thống kê",
        icon: "",
      },
      {
        path: "/declareStatistic-day",
        id: 49,
        name: "Báo cáo công nợ phí, lệ phí khó đòi tính đến ngày",
        icon: "",
      },
      {
        path: "/declareStatistic-people",
        id: 50,
        name: "Báo cáo công nợ, lệ phí khó đòi chi tiết theo đối tượng",
        icon: "",
      },
      {
        path: "/declareStatistic-year",
        id: 51,
        name: "Báo cáo thống kê hoạt động doanh nghiệp theo năm",
        icon: "",
      },
    ],
  },
  // Quản lý danh mục cấu hình

  {
    name: "Quản lý danh mục/ cấu hình",
    icon: "Configuration.svg",
    id: 35,
    path: "",
    childrens: [
      {
        path: "",
        name: "Quản lý danh mục/ cấu hình",
        icon: "",
      },
      {
        name: "Danh mục cơ quan thuế",
        icon: "",
        id: 36,
        path: "/tax-department",
      },
      {
        name: "Cấu hình mức thu phí, lệ phí",
        icon: "",
        id: 37,
        path: "/collection_rates",
      },
      {
        name: "Cấu hình tỷ lệ tờ khai phí, lệ phí",
        icon: "",
        id: 38,
        path: "/declaration-tax",
      },
      {
        name: "Cấu hình biểu mẫu điện tử",
        icon: "",
        id: 39,
        path: "/electronic-form",
      },
      {
        name: "Danh mục đơn vị hành chính",
        icon: "",
        id: 40,
        path: "/list-place",
      },
    ],
  },

  // SMS
  {
    name: "Quản lý tin nhắn SMS",
    icon: "SMS.svg",
    id: 41,
    path: "",
    childrens: [
      {
        name: "Quản lý tin nhắn SMS",
        icon: "",
        path: "",
      },
      {
        name: "Danh sách mẫu tin nhắn",
        icon: "",
        id: 42,
        path: "/sms-company",
      },
      {
        name: "Lịch sử gửi tin nhắn SMS",
        icon: "",
        id: 43,
        path: "/history-sms",
      },
    ],
  },
  //  Quanrn trị hệ thống
  {
    name: "Quản trị hệ thống",
    icon: "Setting.svg",
    path: "",
    id: 45,
    childrens: [
      {
        name: "Quản trị hệ thống",
        icon: "",
        path: "",
      },
      {
        name: "Danh sách tài khoản người dùng",
        icon: "",
        id: 46,
        path: "/user-account",
      },
      {
        name: "Quản lý nhóm quyền",
        icon: "",
        id: 47,
        path: "/user-administrator",
      },
      {
        name: "Lịch sử hệ thống",
        icon: "",
        id: 44,
        path: "/impact-history",
      },

      {
        name: "Tool hệ thống",
        icon: "",
        id: 46,
        path: "/tool-import",
      },
    ],
  },
];
export default data;
